import { render, staticRenderFns } from "./ReviewPlan.vue?vue&type=template&id=2529cd86&scoped=true&"
import script from "./ReviewPlan.vue?vue&type=script&lang=js&"
export * from "./ReviewPlan.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPlan.vue?vue&type=style&index=0&id=2529cd86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2529cd86",
  null
  
)

export default component.exports